"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = exports.ICON_NAME = void 0;
Object.defineProperty(exports, "SvgAddressCard", {
  enumerable: true,
  get: function get() {
    return _AddressCard["default"];
  }
});
Object.defineProperty(exports, "SvgArrowDown", {
  enumerable: true,
  get: function get() {
    return _ArrowDown["default"];
  }
});
Object.defineProperty(exports, "SvgArrowUp", {
  enumerable: true,
  get: function get() {
    return _ArrowUp["default"];
  }
});
Object.defineProperty(exports, "SvgBarcode", {
  enumerable: true,
  get: function get() {
    return _Barcode["default"];
  }
});
Object.defineProperty(exports, "SvgBox", {
  enumerable: true,
  get: function get() {
    return _Box["default"];
  }
});
Object.defineProperty(exports, "SvgBrandGlobe", {
  enumerable: true,
  get: function get() {
    return _BrandGlobe["default"];
  }
});
Object.defineProperty(exports, "SvgCaretDown", {
  enumerable: true,
  get: function get() {
    return _CaretDown["default"];
  }
});
Object.defineProperty(exports, "SvgCaretUp", {
  enumerable: true,
  get: function get() {
    return _CaretUp["default"];
  }
});
Object.defineProperty(exports, "SvgChevronLeft", {
  enumerable: true,
  get: function get() {
    return _ChevronLeft["default"];
  }
});
Object.defineProperty(exports, "SvgChevronLeftDouble", {
  enumerable: true,
  get: function get() {
    return _ChevronLeftDouble["default"];
  }
});
Object.defineProperty(exports, "SvgChevronRight", {
  enumerable: true,
  get: function get() {
    return _ChevronRight["default"];
  }
});
Object.defineProperty(exports, "SvgChevronRightDouble", {
  enumerable: true,
  get: function get() {
    return _ChevronRightDouble["default"];
  }
});
Object.defineProperty(exports, "SvgClipboard", {
  enumerable: true,
  get: function get() {
    return _Clipboard["default"];
  }
});
Object.defineProperty(exports, "SvgCloneUser", {
  enumerable: true,
  get: function get() {
    return _CloneUser["default"];
  }
});
Object.defineProperty(exports, "SvgClose", {
  enumerable: true,
  get: function get() {
    return _Close["default"];
  }
});
Object.defineProperty(exports, "SvgCog", {
  enumerable: true,
  get: function get() {
    return _Cog["default"];
  }
});
Object.defineProperty(exports, "SvgCompanies", {
  enumerable: true,
  get: function get() {
    return _Companies["default"];
  }
});
Object.defineProperty(exports, "SvgEdit", {
  enumerable: true,
  get: function get() {
    return _Edit["default"];
  }
});
Object.defineProperty(exports, "SvgFileAlt", {
  enumerable: true,
  get: function get() {
    return _FileAlt["default"];
  }
});
Object.defineProperty(exports, "SvgGroups", {
  enumerable: true,
  get: function get() {
    return _Groups["default"];
  }
});
Object.defineProperty(exports, "SvgHome", {
  enumerable: true,
  get: function get() {
    return _Home["default"];
  }
});
Object.defineProperty(exports, "SvgListOl", {
  enumerable: true,
  get: function get() {
    return _ListOl["default"];
  }
});
Object.defineProperty(exports, "SvgPasswordReset", {
  enumerable: true,
  get: function get() {
    return _PasswordReset["default"];
  }
});
Object.defineProperty(exports, "SvgPlus", {
  enumerable: true,
  get: function get() {
    return _Plus["default"];
  }
});
Object.defineProperty(exports, "SvgSearch", {
  enumerable: true,
  get: function get() {
    return _Search["default"];
  }
});
Object.defineProperty(exports, "SvgSortDefault", {
  enumerable: true,
  get: function get() {
    return _SortDefault["default"];
  }
});
Object.defineProperty(exports, "SvgTrash", {
  enumerable: true,
  get: function get() {
    return _Trash["default"];
  }
});
Object.defineProperty(exports, "SvgUndo", {
  enumerable: true,
  get: function get() {
    return _Undo["default"];
  }
});
Object.defineProperty(exports, "SvgUnlink", {
  enumerable: true,
  get: function get() {
    return _Unlink["default"];
  }
});
Object.defineProperty(exports, "SvgUnlock", {
  enumerable: true,
  get: function get() {
    return _Unlock["default"];
  }
});
Object.defineProperty(exports, "SvgUpdateUser", {
  enumerable: true,
  get: function get() {
    return _UpdateUser["default"];
  }
});
Object.defineProperty(exports, "SvgUser", {
  enumerable: true,
  get: function get() {
    return _User["default"];
  }
});
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _Undo = _interopRequireDefault(require("../../icons/woodmac/Undo"));
var _Trash = _interopRequireDefault(require("../../icons/woodmac/Trash"));
var _Close = _interopRequireDefault(require("../../icons/woodmac/Close"));
var _Edit = _interopRequireDefault(require("../../icons/woodmac/Edit"));
var _Cog = _interopRequireDefault(require("../../icons/woodmac/Cog"));
var _Home = _interopRequireDefault(require("../../icons/woodmac/Home"));
var _User = _interopRequireDefault(require("../../icons/woodmac/User"));
var _Groups = _interopRequireDefault(require("../../icons/woodmac/Groups"));
var _Companies = _interopRequireDefault(require("../../icons/woodmac/Companies"));
var _BrandGlobe = _interopRequireDefault(require("../../icons/woodmac/BrandGlobe"));
var _ArrowUp = _interopRequireDefault(require("../../icons/woodmac/ArrowUp"));
var _ArrowDown = _interopRequireDefault(require("../../icons/woodmac/ArrowDown"));
var _SortDefault = _interopRequireDefault(require("../../icons/woodmac/SortDefault"));
var _ChevronLeft = _interopRequireDefault(require("../../icons/woodmac/ChevronLeft"));
var _ChevronLeftDouble = _interopRequireDefault(require("../../icons/woodmac/ChevronLeftDouble"));
var _ChevronRight = _interopRequireDefault(require("../../icons/woodmac/ChevronRight"));
var _ChevronRightDouble = _interopRequireDefault(require("../../icons/woodmac/ChevronRightDouble"));
var _CaretUp = _interopRequireDefault(require("../../icons/woodmac/CaretUp"));
var _CaretDown = _interopRequireDefault(require("../../icons/woodmac/CaretDown"));
var _Plus = _interopRequireDefault(require("../../icons/woodmac/Plus"));
var _Search = _interopRequireDefault(require("../../icons/woodmac/Search"));
var _AddressCard = _interopRequireDefault(require("../../icons/font-awesome/AddressCard"));
var _Barcode = _interopRequireDefault(require("../../icons/font-awesome/Barcode"));
var _Box = _interopRequireDefault(require("../../icons/font-awesome/Box"));
var _Clipboard = _interopRequireDefault(require("../../icons/font-awesome/Clipboard"));
var _FileAlt = _interopRequireDefault(require("../../icons/font-awesome/FileAlt"));
var _ListOl = _interopRequireDefault(require("../../icons/font-awesome/ListOl"));
var _Unlock = _interopRequireDefault(require("../../icons/font-awesome/Unlock"));
var _Unlink = _interopRequireDefault(require("../../icons/font-awesome/Unlink"));
var _CloneUser = _interopRequireDefault(require("../../icons/icon8/CloneUser"));
var _UpdateUser = _interopRequireDefault(require("../../icons/icon8/UpdateUser"));
var _PasswordReset = _interopRequireDefault(require("../../icons/icon8/PasswordReset"));
var _SVG;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // Woodmac icons
// Font awesome icons
// Icon8 icons
var ICON_NAME = {
  // Woodmac icons
  ArrowDown: "ArrowDown",
  ArrowUp: "ArrowUp",
  BrandGlobe: "BrandGlobe",
  ChevronLeft: "ChevronLeft",
  ChevronLeftDouble: "ChevronLeftDouble",
  ChevronRight: "ChevronRight",
  ChevronRightDouble: "ChevronRightDouble",
  Close: "Close",
  Cog: "Cog",
  Companies: "Companies",
  Edit: "Edit",
  Home: "Home",
  Groups: "Groups",
  SortDefault: "SortDefault",
  Trash: "Trash",
  Undo: "Undo",
  User: "User",
  CaretUp: "CaretUp",
  CaretDown: "CaretDown",
  // Font awesome icons,
  AddressCard: "AddressCard",
  Barcode: "Barcode",
  Box: "Box",
  Clipboard: "Clipboard",
  FileAlternate: "FileAlternate",
  ListOl: "ListOl",
  Plus: "Plus",
  Search: "Search",
  Unlock: "Unlock",
  Unlink: "Unlink",
  // Icon8 icons
  CloneUser: "CloneUser",
  UpdateUser: "UpdateUser",
  PasswordReset: "PasswordReset"
};
exports.ICON_NAME = ICON_NAME;
var SVG = (_SVG = {}, _defineProperty(_SVG, ICON_NAME.ArrowDown, /*#__PURE__*/_react["default"].createElement(_ArrowDown["default"], null)), _defineProperty(_SVG, ICON_NAME.ArrowUp, /*#__PURE__*/_react["default"].createElement(_ArrowUp["default"], null)), _defineProperty(_SVG, ICON_NAME.BrandGlobe, /*#__PURE__*/_react["default"].createElement(_BrandGlobe["default"], null)), _defineProperty(_SVG, ICON_NAME.Close, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)), _defineProperty(_SVG, ICON_NAME.Cog, /*#__PURE__*/_react["default"].createElement(_Cog["default"], null)), _defineProperty(_SVG, ICON_NAME.Companies, /*#__PURE__*/_react["default"].createElement(_Companies["default"], null)), _defineProperty(_SVG, ICON_NAME.Edit, /*#__PURE__*/_react["default"].createElement(_Edit["default"], null)), _defineProperty(_SVG, ICON_NAME.Home, /*#__PURE__*/_react["default"].createElement(_Home["default"], null)), _defineProperty(_SVG, ICON_NAME.Groups, /*#__PURE__*/_react["default"].createElement(_Groups["default"], null)), _defineProperty(_SVG, ICON_NAME.Trash, /*#__PURE__*/_react["default"].createElement(_Trash["default"], null)), _defineProperty(_SVG, ICON_NAME.Undo, /*#__PURE__*/_react["default"].createElement(_Undo["default"], null)), _defineProperty(_SVG, ICON_NAME.User, /*#__PURE__*/_react["default"].createElement(_User["default"], null)), _defineProperty(_SVG, ICON_NAME.ArrowUp, /*#__PURE__*/_react["default"].createElement(_ArrowUp["default"], null)), _defineProperty(_SVG, ICON_NAME.ArrowDown, /*#__PURE__*/_react["default"].createElement(_ArrowDown["default"], null)), _defineProperty(_SVG, ICON_NAME.SortDefault, /*#__PURE__*/_react["default"].createElement(_SortDefault["default"], null)), _defineProperty(_SVG, ICON_NAME.CaretUp, /*#__PURE__*/_react["default"].createElement(_CaretUp["default"], null)), _defineProperty(_SVG, ICON_NAME.CaretDown, /*#__PURE__*/_react["default"].createElement(_CaretDown["default"], null)), _defineProperty(_SVG, ICON_NAME.AddressCard, /*#__PURE__*/_react["default"].createElement(_AddressCard["default"], null)), _defineProperty(_SVG, ICON_NAME.Barcode, /*#__PURE__*/_react["default"].createElement(_Barcode["default"], null)), _defineProperty(_SVG, ICON_NAME.Box, /*#__PURE__*/_react["default"].createElement(_Box["default"], null)), _defineProperty(_SVG, ICON_NAME.Clipboard, /*#__PURE__*/_react["default"].createElement(_Clipboard["default"], null)), _defineProperty(_SVG, ICON_NAME.FileAlternate, /*#__PURE__*/_react["default"].createElement(_FileAlt["default"], null)), _defineProperty(_SVG, ICON_NAME.ListOl, /*#__PURE__*/_react["default"].createElement(_ListOl["default"], null)), _defineProperty(_SVG, ICON_NAME.Plus, /*#__PURE__*/_react["default"].createElement(_Plus["default"], null)), _defineProperty(_SVG, ICON_NAME.Search, /*#__PURE__*/_react["default"].createElement(_Search["default"], null)), _defineProperty(_SVG, ICON_NAME.Unlock, /*#__PURE__*/_react["default"].createElement(_Unlock["default"], null)), _defineProperty(_SVG, ICON_NAME.Unlink, /*#__PURE__*/_react["default"].createElement(_Unlink["default"], null)), _defineProperty(_SVG, ICON_NAME.CloneUser, /*#__PURE__*/_react["default"].createElement(_CloneUser["default"], null)), _defineProperty(_SVG, ICON_NAME.UpdateUser, /*#__PURE__*/_react["default"].createElement(_UpdateUser["default"], null)), _defineProperty(_SVG, ICON_NAME.PasswordReset, /*#__PURE__*/_react["default"].createElement(_PasswordReset["default"], null)), _SVG);
var IconButton = function IconButton(props) {
  var buttonProps = Object.assign({}, props, {
    className: props.className ? props.className + " svg-button" : "svg-button"
  });
  delete buttonProps.iconName; // prevents spreading the icoName prop into <Button> (causing "React does not recognize the `iconName` prop" console error)
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, buttonProps, SVG[props.iconName]);
};
exports.IconButton = IconButton;
IconButton.propTypes = {
  iconName: _propTypes["default"].string.isRequired
};